import { FC } from 'react';
import ReportWrapperWeb from '@/module/reports/ReportWrapper.web';
import ReportWrapper from '@/module/reports/ReportWrapper';

const Reports: FC<{ isWeb?: boolean }> = ({ isWeb }) => {
  return (
    <div className="w-full flex items-center justify-center">
      {isWeb ? <ReportWrapperWeb /> : <ReportWrapper />}
    </div>
  );
};

export default Reports;
